// extracted by mini-css-extract-plugin
module.exports = {"qr":"qr_qr__aSrY-"};